import React from "react";
import { OnboardingFormProps } from "../Types";

const LoomStep: React.FC<OnboardingFormProps> = () => {
  return (
    <div style={{ width: "100%", maxWidth: "800px", textAlign: "left" }}>
      <h1>🧪 Welcome to Potions</h1>
      <p style={{ marginTop: 0, marginBottom: "24px", color: "#6b7280" }}>
        Watch this quick walkthrough to get oriented. We'll show you everything you need to know to get started.
      </p>

      <div style={{ position: "relative", paddingBottom: "56.25%", height: 0, borderRadius: "12px", overflow: "hidden", marginBottom: "24px", backgroundColor: "#e5e7eb" }}>
        <iframe
          src="https://www.loom.com/embed/8099b7df8d9c4fa5a98b97ced41fee4b?hide_owner=true&hide_share=true&hide_title=true&hideEmbedTopBar=true&autoplay=1&muted=1&default_speed=1.5"
          allowFullScreen
          style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", border: "none" }}
          title="Potions Walkthrough"
        />
      </div>

      <p style={{ color: "#6b7280", fontSize: "14px" }}>
        Have questions? Email us at{" "}
        <a href="mailto:team@withpotions.com" target="_blank" rel="noreferrer" style={{ color: "#6b7280" }}>
          team@withpotions.com
        </a>
      </p>
    </div>
  );
};

export default LoomStep;
